<div class="modal-header flex-shrink-0">
  <h4 class="modal-title"> {{'customArticlePopup.title' | translate}}</h4>
</div>

<div class="modal-body pt-0">
  <div class="modal-body-inner">
    <table class="table table-hover table-striped fixed-layout" fixedHeader>
      <thead>
      <tr>
        <th width="22%">{{'customArticlePopup.label.custom_article_number' | translate}}</th>
        <th width="20%">{{'customArticlePopup.label.description' | translate}}</th>
        <th width="12%">{{'customArticlePopup.label.width_short' | translate}}</th>
        <th width="12%">{{'customArticlePopup.label.height_short' | translate}}</th>
        <th width="12%">{{'customArticlePopup.label.depth_short' | translate}}</th>
        <th width="12%">{{'customArticlePopup.label.depthoffset_short' | translate}}</th>
        <th class="dots" [class.c-default]="readonly">
            <button
              (click)="addArticle()"
              class="btn btn-primary btn-sm"
              tooltip
              [tooltipText]="'global.label.add' | translate"
              data-testid="add-user-defined-item">
              <app-svg-icon type="plus" size="small"/>
            </button>
        </th>
      </tr>
      </thead>
    </table>
    <div class="container-custom-list" maxHeightOffset="230">
      <table class="table table-hover table-striped fixed-layout mb-0 table-wrap">
        <tbody minRowCount [update]="update">
        <tr *ngFor="let articleInfo of customArticleInfoMap.keys(); let i = index"
            [class.active]="articleInfo === selectedArticleInfo">
          <td width="22%" (click)="toggleInfo(articleInfo)">{{articleInfo.articleNumber}}</td>
          <td width="20%" (click)="toggleInfo(articleInfo)">{{articleInfo.articleDescription}}</td>
          <td width="12%" (click)="toggleInfo(articleInfo)">{{customArticleInfoMap.get(articleInfo).articleWidth}}</td>
          <td width="12%" (click)="toggleInfo(articleInfo)">{{customArticleInfoMap.get(articleInfo).articleHeight}}</td>
          <td width="12%" (click)="toggleInfo(articleInfo)">{{customArticleInfoMap.get(articleInfo).articleDepth}}</td>
          <td width="12%" (click)="toggleInfo(articleInfo)">{{customArticleInfoMap.get(articleInfo).articleDepthOffset}}</td>
          <td width="10%" class="dots" [class.c-default]="readonly">
            <span class="dropdown" dropdown #dropdown="bs-dropdown" [isDisabled]="readonly" [dropup]="i === library.customArticleInfos.length - 1 && i > 0 ">
                <a data-toggle="dropdown" dropdownToggle (click)="false" [ngClass]="{
                   'c-default': readonly,
                   'event-disabled': readonly}">
                  <i class="mdi mdi-dots-vertical small"
                     [ngClass]="{
                        'c-default': readonly,
                        'c-pointer': !readonly,
                        'disabled': readonly
                        }"></i></a>
                <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
                  <li><a class="dropdown-item" (click)="editArticleInfo(articleInfo)"><app-svg-icon type="edit-pen" size="medium-small"/>{{'global.label.edit' | translate}}</a></li>
                  <li><a class="dropdown-item" (click)="deleteArticleInfo(articleInfo)"><app-svg-icon type="delete" size="medium-small"/>{{'global.label.delete' | translate}}</a></li>
                </ul>
            </span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="modal-footer flex-shrink-0">
  <button id="button_close" type="button" class="btn btn-secondary btn-cancel" (click)="close()">
    {{'global.label.close' | translate}}
  </button>
</div>
